<!--
/*******************************************************************************
*@ 컴포넌트명   : TrsaccInfoInptUpdate.vue
*@ 컴포넌트설명 : 당행이체 - 입금계좌수정
*@ 사용전문     :  
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2023.04.24   이가영   (베트남) 송금메모/수취인참조내용 영어, 숫자, 띄어쓰기, 특수문자 - / 허용
********************************************************************************/
-->
<template>
  <section>
    <popup :opened.sync="openData" :use-header="true" :use-footer="true" :btn-area-padding="true" title="MPAY-02-01-31-01">
      <template #content>
        <div class="form">
          <div class="form-row">
            <mnrcv-acno ref="mnrcvAcno" inAcnKnd="1" inAcnDtlKnd="2" :value.sync="account" obaob-dstcd="1" page="transfer" @selected="changeAcno" @click="clickAcno" />
          </div>
          <div class="form-row">
            <div class="item-tit">{{ /*입금금액*/ $t("MPAY-01-01-10-02") }}</div>
            <div class="item-desc">
              <div class="form-multi-group--type2">
                <span class="unit">{{ amtData.mnrcvCncycd }}</span>
                <div required="required">
                  <div class="form-text-field">
                    <div class="input-text-field">
                      <input type="text" id="mnrcvAmt01" class="form-control" :value="$num(mnrcvAmt01, 0, true)" disabled />
                      <span class="default-number">
                        <em>{{ mnrcvAmt02 }}</em>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row" v-if="amtData.mnrcvCncycd != amtData.drwotCncycd">
            <div class="item-tit">{{ /*출금금액*/ $t("MPAY-01-01-09-05") }}</div>
            <div class="item-desc">
              <div class="form-multi-group--type2">
                <span class="unit">{{ amtData.drwotCncycd }}</span>
                <div required="required">
                  <div class="form-text-field">
                    <div class="input-text-field">
                      <input type="text" id="drwotAmt01" class="form-control" :value="$num(drwotAmt01, 0, true)" disabled />
                      <span class="default-number">
                        <em>{{ drwotAmt02 }}</em>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="btn-area">
              <button class="btn lg inline" @click="onMnrcvAmt">{{ /*금액변경*/ $t("MPAY-01-01-10-03") }}</button>
            </div>
          </div>
          <div class="form-row">
            <input-text
              ref="drwotRmark"
              id="drwotRmark"
              :value.sync="mnrcvTmp.drwotRmark"
              :labelI18n="`${siteCode == $config.SITECODE_OGMMR ? /*송금메모(송금목적)*/ 'MPAY-01-01-11-12' : /*송금메모*/ 'MPAY-01-01-11-05'}`"
              placeholder="MPAY-01-01-11-06"
              :localeNum="`${$config.SITECODE_OGMMR}|${$config.SITECODE_OGCBD}`"
              :alphaLocaleOnly3="`${$config.SITECODE_OGHCM}`"
              :alphaNum="`${$config.SITECODE_OGIND}|${$config.SITECODE_OGAUC}`"
              :maxByte="`${$config.SITECODE_OGMMR}=48|${$config.SITECODE_OGCBD}=48|${$config.SITECODE_OGHCM}=60|${$config.SITECODE_OGIND}=48|${$config.SITECODE_OGAUC}=48`"
            />
          </div>
          <div class="form-row">
            <input-text
              ref="mnrcvRmark"
              id="mnrcvRmark"
              :value.sync="mnrcvTmp.mnrcvRmark"
              labelI18n="MPAY-01-01-11-07"
              placeholder="MPAY-01-01-10-12"
              :localeNum="`${$config.SITECODE_OGMMR}|${$config.SITECODE_OGCBD}`"
              :alphaLocaleOnly3="`${$config.SITECODE_OGHCM}`"
              :alphaNum="`${$config.SITECODE_OGIND}|${$config.SITECODE_OGAUC}`"
              :maxByte="`${$config.SITECODE_OGMMR}=48|${$config.SITECODE_OGCBD}=48|${$config.SITECODE_OGHCM}=60|${$config.SITECODE_OGIND}=48|${$config.SITECODE_OGAUC}=48`"
            />
          </div>
        </div>
      </template>
      <template #footer>
        <button class="btn bottom positive" v-show="showCfmBtn" @click.prevent="onUpdateCfm">{{ /*확인*/ $t("MCOM-0000003") }}</button>
      </template>
    </popup>
    <mnrcv-trsacc-amt ref="mnrcvTrasccAmt" :opened.sync="openedMnrcvAmt" :acno-info="acno" :info.sync="amtData" page="transfer" />
    <modal-pop :opened.sync="openedError" class="modal" confirm="MCOM-0000003">
      <template #content>{{ minAmt >= 0 ? $t(errMsg, { min: minAmt }) : $t(errMsg) }}</template>
    </modal-pop>
  </section>
</template>

<script>
import MnrcvAcno from "@/components/page/common/MnrcvAcno";
import MnrcvTrsaccAmt from "@/components/page/common/MnrcvTrsaccAmt";
import { mnrcvTrsaccCheck } from "@/mixins/transfer";
import { mapFields } from "vuex-map-fields";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [mnrcvTrsaccCheck],
  components: {
    MnrcvAcno,
    MnrcvTrsaccAmt,
  },
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    mnrcvIdx: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      account: [],
      //입금금액입력
      acno: {
        drwotAcno: "", //출금계좌번호
        drwotAbilAmt: "", //출금가능금액
        dailyTrsaccAcamtRmainLimt: "", // 1일이체잔여한도
      },
      amtData: {
        fxTranz: "", //FX환산 (01: 입금->출금금액 환산, 02: 출금->입금금액 환산)
        drwotCncycd: "", //출금계좌 통화코드
        mnrcvCncycd: "", // 입금계좌 통화코드
        drwotAmt: "", //출금금액
        mnrcvAmt: "", //입금금액
      },
      minAmt: 0,
      errMsg: "",
      openedMnrcvAmt: false, //금액변경 팝업
      openedError: false, //오류알림 팝업
      showCfmBtn: true, //확인버튼 표시
    };
  },
  computed: {
    ...mapFields(["siteCode", "sessionInfo"]),
    ...mapFields("transfer/trsaccInfoInpt", ["mnrcvTmp"]),
    ...mapGetters("transfer/trsaccInfoInpt", ["getTrsaccDrwotInfo"]),
    openData: {
      get() {
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },
    },
    mnrcvAmt01() {
      if (!"string|number".includes(typeof this.amtData.mnrcvAmt)) return 0;

      let strAmt = String(this.amtData.mnrcvAmt);

      if (strAmt.indexOf(".") > -1) return strAmt.split(".")[0];
      else return strAmt;
    },
    mnrcvAmt02() {
      let strAmt = String(this.amtData.mnrcvAmt);

      if (strAmt.indexOf(".") > -1) return "." + _.padEnd(strAmt.split(".")[1], 2, "0");
      else return ".00";
    },
    drwotAmt01() {
      if (!"string|number".includes(typeof this.amtData.drwotAmt)) return 0;

      let strAmt = String(this.amtData.drwotAmt);

      if (strAmt.indexOf(".") > -1) return strAmt.split(".")[0];
      else return Number(strAmt);
    },
    drwotAmt02() {
      let strAmt = String(this.amtData.drwotAmt);

      if (strAmt.indexOf(".") > -1) return "." + _.padEnd(strAmt.split(".")[1], 2, "0");
      else return ".00";
    },
  },
  methods: {
    ...mapActions("transfer/trsaccInfoInpt", ["ACT_modTrasccMnrcvInfo"]),
    async init() {
      //출금계좌 정보
      this.acno.drwotAcno = this.getTrsaccDrwotInfo.acno; //출금계좌번호
      this.acno.drwotAbilAmt = this.getTrsaccDrwotInfo.drwotAbilAmt; //출금가능금액
      this.acno.dailyTrsaccAcamtRmainLimt = this.getTrsaccDrwotInfo.dailyTrsaccAcamtRmainLimt; //1일이체잔여한도

      //입출금 정보
      this.amtData.fxTranz = this.mnrcvTmp.fxTranz ? this.mnrcvTmp.fxTranz : "01"; // FX환산 (01: 입금->출금금액 환산, 02: 출금->입금금액 환산)
      this.amtData.drwotCncycd = this.getTrsaccDrwotInfo.cncycd; //출금계좌 통화코드
      this.amtData.mnrcvCncycd = this.mnrcvTmp.cncycd; // 입금계좌 통화코드

      if (this.getTrsaccDrwotInfo.cncycd != this.mnrcvTmp.cncycd) {
        this.amtData.mnrcvAmt = this.mnrcvTmp.mnrcvAmt ? this.mnrcvTmp.mnrcvAmt : 0; //입금금액
        this.amtData.drwotAmt = this.mnrcvTmp.fxTranzAmt ? this.mnrcvTmp.fxTranzAmt : 0; //출금금액
      } else {
        this.amtData.mnrcvAmt = this.mnrcvTmp.mnrcvAmt ? this.mnrcvTmp.mnrcvAmt : 0; //입금금액
      }

      await this.$refs.mnrcvTrasccAmt.init();
      await this.$refs.mnrcvAcno.setText(this.mnrcvTmp.acno);
    },
    changeAcno(acnoInfo) {
      this.$log.info({ acnoInfo: acnoInfo });
      this.showCfmBtn = true;

      if (!_.isEmpty(acnoInfo.cncycd)) {
        this.changeCncycd(acnoInfo.cncycd);
      }
    },
    changeCncycd(newValue) {
      let value = this.amtData.mnrcvCncycd;
      if (value == newValue) return;

      if (this.amtData.drwotCncycd != newValue) {
        this.amtData.mnrcvAmt = 0; //입금금액
        this.amtData.drwotAmt = 0; //출금금액
      } else {
        this.amtData.drwotAmt = 0; //출금금액
      }

      this.amtData.mnrcvCncycd = newValue;
    },
    async onMnrcvAmt() {
      await this.$refs.mnrcvTrasccAmt.init();
      this.openedMnrcvAmt = true;
    },
    async onUpdateCfm() {
      this.$refs.mnrcvAcno.$refs.mnrcvAcno.$v.$touch();
      this.$refs.drwotRmark.$v.$touch();
      this.$refs.mnrcvRmark.$v.$touch();

      if (this.$refs.mnrcvAcno.$refs.mnrcvAcno.$v.$invalid || this.$refs.drwotRmark.$v.$invalid || this.$refs.mnrcvRmark.$v.$invalid) return;

      let trsaccDstcd = this.sessionInfo.userInfo.baseCncycd == this.amtData.drwotCncycd && this.amtData.drwotCncycd == this.amtData.mnrcvCncycd ? "01" : "02"; //이체구분 (01: 당행, 02: 외화)
      let mnrcvInfo = await this.$refs.mnrcvAcno.getAcnoInfoAsync();

      if (_.isNil(mnrcvInfo.acno) || _.isEmpty(mnrcvInfo.acno)) {
        this.minAmt = null;
        this.errMsg = "MPAY-01-01-03-10"; //입력하신 번호는 유효하지 않은 계좌번호입니다.
        this.openedError = true;
        return;
      }

      if (mnrcvInfo.cncycd != this.amtData.mnrcvCncycd) {
        this.changeCncycd(mnrcvInfo.cncycd);
      }

      this.minAmt = this.getMinTrsaccAmt(this.amtData.fxTranz, this.amtData.mnrcvCncycd, this.amtData.drwotCncycd, "transfer");

      let amt;

      if (this.amtData.drwotCncycd != this.amtData.mnrcvCncycd && this.siteCode == this.$config.SITECODE_OGAUC) {
        amt = this.amtData.drwotCncycd == "NZD" ? this.amtData.drwotAmt : this.amtData.mnrcvAmt;
      } else {
        amt = this.amtData.mnrcvAmt;
      }

      if (Number(amt) < Number(this.minAmt)) {
        this.errMsg = "validations.amtMinValue"; //금액은 {min}이상 입력하셔야 합니다.
        this.openedError = true;
        return;
      }

      this.mnrcvTmp.acno = mnrcvInfo.acno; //입금계좌번호
      this.mnrcvTmp.acnoAls = mnrcvInfo.alias; //입금계좌별명
      this.mnrcvTmp.cncycd = mnrcvInfo.cncycd; //입금통화코드

      this.mnrcvTmp.trsaccDstcd = trsaccDstcd; //이체구분 (01: 당행, 02: 외화)
      this.mnrcvTmp.mnrcvAmt = this.amtData.mnrcvAmt; //입금금액
      this.mnrcvTmp.fxTranzAmt = this.amtData.drwotAmt; //출금금액
      this.mnrcvTmp.fxTranz = this.amtData.fxTranz; //FX 환산

      this.ACT_modTrasccMnrcvInfo(this.mnrcvIdx);
      this.openData = false;
    },
    clickAcno() {
      this.showCfmBtn = !this.showCfmBtn;
    },
  },
};
</script>
